import './Join.scss';

const Join = (() => {})();

export default Join;
